import { render, staticRenderFns } from "./InventoryForecast.vue?vue&type=template&id=720d299c&"
import script from "./InventoryForecast.vue?vue&type=script&lang=js&"
export * from "./InventoryForecast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports